const UserAgentDetector = function () {
    this.getCurrentUserAgent = function () {
        return window.navigator.userAgent;
    };

    this.isIE = function () {
        const userAgentNameVariants = ['MSIE', 'Trident'];
        return userAgentNameVariants.some(variant =>
            this.getCurrentUserAgent().includes(variant)
        );
    };

    this.isEdge = function () {
        return this.getCurrentUserAgent().includes('Edge');
    };

    this.isBot = function () {
        const lowerCaseUA = this.getCurrentUserAgent().toLowerCase();
        const bots = ['bot', 'spider', 'crawl', 'bingpreview'];
        return bots.some(bot => lowerCaseUA.includes(bot));
    };
};

export { UserAgentDetector };
